// Canonical invoice status vocabulary.
//
// `invoice.status` is free-text. The live EasyBill sync writes 'Issued', but
// rows brought in by the now-retired EasyBill webhook still carry the legacy
// 'Sent' — the same payable, voidable lifecycle state under an older name.
// Every status-driven decision (which actions render, how the status reads)
// runs through this alias map so a legacy value can never again leave an
// issued receivable un-actionable: the action model and labels only ever see
// the canonical form.
const STATUS_ALIASES: Readonly<Record<string, string>> = {
  Sent: 'Issued',
};

export function canonicalInvoiceStatus(status: string | null): string | null {
  if (status === null) return null;
  return STATUS_ALIASES[status] ?? status;
}
